const heroModule = document.querySelectorAll('[data-slider="hero-module-slider"]');

const heroModuleOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 800,
  loop: true,
  // autoplay: {
  //   enabled: true,
  //   disableOnInteraction: false,
  //   delay: 5000,
  // },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
};

heroModule.forEach((el) => {
  new Swiper(el, heroModuleOptions);
});
